'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var marker = '/mark.png';
// import marker from 'assets/img/detail/mark.png';
var Marker = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Marker, _Component);

  function Marker() {
    (0, _classCallCheck3.default)(this, Marker);
    return (0, _possibleConstructorReturn3.default)(this, (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).apply(this, arguments));
  }

  (0, _createClass3.default)(Marker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          lat = _props.lat,
          lng = _props.lng;

      return _react2.default.createElement('img', {
        style: {
          width: '47px',
          height: '41px',
          position: 'absolute',
          top: '-41px',
          left: '-23px'
        },
        lat: lat,
        lng: lng,
        className: 'MapMarkerImage',
        src: marker
      });
    }
  }]);
  return Marker;
}(_react.Component), _class.propTypes = {
  lat: _react.PropTypes.number,
  lng: _react.PropTypes.number
}, _temp);
exports.default = Marker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/Marker.js
// module id = 713
// module chunks = 0